import react from "react";
import Pathfinder from "./components/pathfinder/Pathfinder";

function App() {
  return (
    <div>
      <Pathfinder />
    </div>
  );
}

export default App;
